<script setup lang="ts">
import { useAnalytics } from "@/composables/useAnalytics";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const { isOpen, closeModal, bookingUrl } = useCalCom();
const { trackAppointmentBooked } = useAnalytics();

const handleCalEvent = (event: MessageEvent) => {
  if (event.origin !== "https://cal.com") return;

  const data = event.data;
  console.log("[CalCom] Event Received", data.type, data);
  const type = typeof data === "string" ? data : data?.type;

  // Cal.com sends events as postMessage
  // Format is usually { action: "bookingSuccessful", payload: { ... } }
  if (type === "bookingSuccessful") {
    console.log("[CalCom] Booking Successful", data);
    trackAppointmentBooked({
      url: bookingUrl.value,
      ...data?.payload,
    });
  }
};

onMounted(() => {
  window.addEventListener("message", handleCalEvent);
});

onBeforeUnmount(() => {
  window.removeEventListener("message", handleCalEvent);
});
</script>

<template>
  <Modal :open="isOpen" @close="closeModal">
    <template #title>
      <span>{{ t("common.modal_booking_title") }}</span>
    </template>
    <template #content>
      <div class="w-full h-[600px] overflow-hidden">
        <iframe
          v-if="isOpen"
          :src="`${bookingUrl}?embed=true`"
          style="width: 100%; height: 100%; border: none"
          allowfullscreen
        ></iframe>
      </div>
    </template>
  </Modal>
</template>

<style scoped>
/* Ensure the modal content can accommodate the iframe well */
:deep(.max-w-\[750px\]) {
  max-width: 900px !important;
}

/* Fix double scrollbar by hiding the modal's internal scrollbar when this modal is open */
:deep([role="alertdialog"]) {
  overflow-y: hidden !important;
}
</style>
